import LayoutPage from '@/components(new)/layout/LayoutBases/LayoutAnalise/LayoutAnalise.vue'
import menuOptions from '@/libs/constants/painel/vistoria/menu.js'
import { items } from './routes'

const cadastro = [
  {
    path: '/vistoria',
    name: 'vistoria',
    component: LayoutPage,
    props: {
      menuOptions: menuOptions
    },
    redirect: '/vistoria/caixa-entrada',
    children: [...items]
  }
]

export default cadastro



// WEBPACK FOOTER //
// ./src/router/vistoria/index.js